import styled from 'styled-components';

export default styled.div`
  text-align: center;
  font-size: 18px;

  .actions {
    display: grid;
    margin-top: 53px;
    grid-gap: 11px;
    grid-template-columns: 278px;
    justify-content: center;

    &.isGoalEvent {
      grid-template-columns: 73px 205px;
    }
  }
`;
